import { createReducer, on, Action } from '@ngrx/store';
import { documentFiltersAction } from '../actions/documentFilters.action';
import { FilterDocumentsType } from '../../../modules/documentos/services/documents.service';

export interface DocumentsStore {
	filters: FilterDocumentsType
}

const initialState: DocumentsStore = {
	filters: {
		id_category: '',
		id_subcategory: '',
		id_municipality: '',
		id_document: '',
		no_uploaded: false,
		id_institution: '',
	}
};

const _documentsModuleReducer = createReducer<DocumentsStore, Action>(
	initialState,
	on(documentFiltersAction, (state, action) => ({
		...state,
		filters: {
			id_category: action.id_category,
			id_municipality: action.id_municipality,
			id_subcategory: action.id_subcategory,
			id_document: action.id_document,
			id_institution: action.id_institution,
			no_uploaded: action.no_uploaded ?? false
		}
	})),
);

export function documentsReducer(state: DocumentsStore = initialState, action: Action) {
	return _documentsModuleReducer(state, action);
}
